import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { PrivateRoute } from './components/Auth/privateRoute';

import { NotificationProvider } from './components/Notification/NotificationProvider';
import ErrorHandler from './components/Notification/ErrorHandler';
import { GlobalContextProvider } from './services/globalContext';

import routes from './routes.js'

import './css/layout.css';
import './css/layout-yangaroo.css';
import './css/layout-animations.css';

export default class App extends Component {
    static displayName = App.name;

    getRoutes = (routes) => {
        return routes.map((prop, key) => {
            const { auth, component: Component, componentLayout: ComponentLayout, pageName, path, ...rest } = prop;
            if (auth) {
                return <PrivateRoute
                    key={key}
                    routes={routes}
                    component={Component}
                    componentLayout={ComponentLayout}
                    pageName={pageName}
                    path={path}
                    {...rest}
                />
            }
            else {
               
                return <Route key={key} path={path} {...rest}
                    render={({...routeProps}) => {
                        return <ComponentLayout routes={routes} pageName={pageName} path={path} childComponent={Component} {...rest} {...routeProps}></ComponentLayout>
                    }} />
            }
        });
    };

    render() {
        return (
            <GlobalContextProvider>
                <NotificationProvider>
                    <Switch>
                        {this.getRoutes(routes)}
                        <Redirect from="*" to="/home" />
                    </Switch>
                    <ErrorHandler />
                </NotificationProvider>
            </GlobalContextProvider>
        );
    }
}
